angular.module('admin')
  .controller('AgentsCtrl', ['$scope', '$state', 'AgentService', 'UserService', 'OfficeService','AccountService', 'HelperService'
    , function($scope, $state, AgentService, UserService, OfficeService, AccountService, helpers){

    $scope.officeId = $state.params.officeId;
    $scope.accountService = AccountService;

    $scope.agentFilter = function(row){
      let regexQuery = new RegExp($scope.query, 'i');
      return (
        !$scope.query ||
        (regexQuery.test(row.first_name)) ||
        (regexQuery.test(row.last_name)) ||
        (regexQuery.test(row.email)) ||
        (regexQuery.test(row.nmls))
      );
    };

    $scope.getAllAgents = function(){
      let params;

      if ($scope.officeId) {
        params = {filter:{where:{'officeId': $scope.officeId}}};
      } else if ($state.is('admins.agentBKSearch')) {
        params = {filter:{where:{'source': 'bkfs'}}};
      } else {
        params = {};
      }

      $scope.loading = true;

      AgentService.getAll(params)
        .then((data) => {
          $scope.agents = data;
          $scope.loading = false;
        })
        .catch((err) => {
          $scope.error = err;
          $scope.loading = false;
        });
    };

    $scope.refreshData = function(){
      $scope.getAllAgents();
    };

    $scope.hasAgents = function(){
      return $scope.agents.length > 0;
    };

    $scope.refreshData();

  }]);
